import { Platform, StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    width: '100%',
    height: '100%',
  },

  content: {
    width: '100%',
    opacity: 0.75,
  },

  contentContainer: {
    ...Platform.select({
      web: { height: '100%' },
    }),
  },

  visible: {
    opacity: 1,
  },
});
